import React from "react";

function Cancel() {
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  return (
    <p>
      <li>
        <strong>Booking Confirmation</strong>
        <br />
        The entire booking amount must be paid in advance to reserve/block your stay at any of our properties.
      </li>
      <li style={{ marginTop: "10px" }}>
        <strong>Free Cancellation (Within 48 Hours)</strong> A full refund will be issued if you cancel within 48 hours of making your payment. (This does not apply for Christmas, New Year’s Eve, and long weekends.)
      </li>
      <li style={{ marginTop: "10px" }}>
        <strong>Refund Timeline</strong>
        <br />
        <strong>100% Refund</strong> For cancellations made up to 1 month before the check-in date.
        <br />
        <strong>75% Refund</strong> For cancellations made between 1 month and 15 days before the check-in date.
        <br />
        <strong>50% Refund</strong> For cancellations made upto 15 days and 7 days before the check-in date.
        <br />
        <strong>No Refund</strong> For cancellations made less than 7 days before the check-in date.(This applies even if the cancellation is requested within 48 hours of booking.)
      </li>
      <li style={{ marginTop: "10px" }}>
        <strong>Processing Timeline</strong> Refunds (where applicable) will be processed within 7 working days. Please note that convenience charges and payment gateway fees are non-refundable.
      </li>
      <li style={{ marginTop: "10px" }}> 
        <strong>External Events Clause</strong>
        <br />
        In the event of geopolitical disturbances, natural disasters, or government advisories that impact travel, we understand that plans may need to change. In such cases, we offer a credit note equivalent to the booking value, valid for 5 months, which can be redeemed only at the same property. If the credit note is used for peak dates, the guest will be required to pay the difference as per the rates applicable at the time of rebooking. This approach allows us to support our guests and also our small business partners during uncertain times.
        <br />
        <strong>Please note: Refunds will not be issued under these circumstances.</strong>
      </li>
      {/* <li>
      {/* <li>
        Cancellation refunds will be processed within 7 Working days. In case of
        any cancellation under any policy, convenience charges and payment
        gateway charges are non-refundable.
      </li> */}
      {/* {/* <li>
      </li> */}
      {/* {/* <li>
        <strong>Covid Cancellation:</strong> If any member of your group tests
        positive for covid, then you will be entitled to travel credit for the
        coming year (i.e. if the check in is 12 PM, December 20, 2022, you will
        be able to use travel credit to check in till or before 12 PM, December
        20, 2023) upon furnishing their covid positive report.
      </li> 
      {/* <li>
      </li> 
      {/* <li>
        <strong>Cancellation Due to External Events Clause:</strong> In the event of geopolitical disturbances, natural disasters, or
        government advisories that impact travel, we understand that plans may
        need to change. In such cases, we offer a credit note equivalent to
        the booking value, valid for 5 months, which can be redeemed only at
        the same property.
        <br />
        If the credit note is used for peak dates, the guest will be required
        to pay the difference as per the rates applicable at the time of
        rebooking.
        <br />
        This approach allows us to support our guests and also our small
        business partners during uncertain times.
        <br />
        <strong>Please note:</strong> Refunds will not be issued under these
        circumstances.
      </li> */}
    </p>
  );
}

export default Cancel;
